import { render } from "./TermForm.vue?vue&type=template&id=3dbf2d7a&ts=true"
import script from "./TermForm.vue?vue&type=script&lang=ts"
export * from "./TermForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__